module.exports = __webpack_public_path__ + "f49842c13ae1ce03f7fcc2929f1badab.jpg";